import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import MarketingService from "services/MarketingService";

const initialState = {
  loading: false,
  campaigns: [],
  stats: {
    total: 0,
    sent: 0,
    scheduled: 0,
    draft: 0,
    total_delivered: 0,
  },
  templates: [],
  templatesLoading: false,
  aiConfigured: false,
  message: "",
  showMessage: false,
  filters: {
    status: null,
    channel: null,
  },
};

export const getCampaigns = createAsyncThunk(
  "marketing/getCampaigns",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await MarketingService.getCampaigns(filters);
      return {
        campaigns: response.data || [],
        stats: response.stats || initialState.stats,
        filters,
      };
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching campaigns");
    }
  },
);

export const getTemplates = createAsyncThunk(
  "marketing/getTemplates",
  async (channel = null, { rejectWithValue }) => {
    try {
      const response = await MarketingService.getTemplates(channel);
      return response.data || [];
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching templates");
    }
  },
);

export const getAiSettings = createAsyncThunk(
  "marketing/getAiSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await MarketingService.getAiSettings();
      return !!response.configured;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching AI settings");
    }
  },
);

const marketingSlice = createSlice({
  name: "marketing",
  initialState,
  reducers: {
    clearMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaigns.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.campaigns = payload.campaigns;
        state.stats = payload.stats || state.stats;
        state.filters = payload.filters || state.filters;
      })
      .addCase(getCampaigns.rejected, (state, { payload }) => {
        state.loading = false;
        state.message = payload;
        state.showMessage = true;
      })
      .addCase(getTemplates.pending, (state) => {
        state.templatesLoading = true;
      })
      .addCase(getTemplates.fulfilled, (state, { payload }) => {
        state.templatesLoading = false;
        state.templates = payload;
      })
      .addCase(getTemplates.rejected, (state, { payload }) => {
        state.templatesLoading = false;
        state.message = payload;
        state.showMessage = true;
      })
      .addCase(getAiSettings.fulfilled, (state, { payload }) => {
        state.aiConfigured = payload;
      });
  },
});

export const { clearMessage } = marketingSlice.actions;
export default marketingSlice.reducer;
